export enum ComboPayloadEnum { PHRASING, EXTRA_POINTS }

const idsComboPayload = new Map<ComboPayloadEnum, string>();
idsComboPayload.set(ComboPayloadEnum.PHRASING, "phrasing");
idsComboPayload.set(ComboPayloadEnum.EXTRA_POINTS, "score_earning");

export const obtenerIdComboPayload: (comboPayload: ComboPayloadEnum) => string =
        comboPayload => idsComboPayload.get(comboPayload) ?? "";
